import React from 'react'

function toReactNode(item: unknown): React.ReactNode {
  if (typeof item === 'string' || typeof item === 'number') {
    return item
  }

  if (item instanceof Date) {
    return item.toISOString()
  }

  if (React.isValidElement(item)) {
    return item
  }

  return null
}
export { toReactNode }
